import { useTranslate } from '@refinedev/core';
import { Card, Flex, Typography, theme } from 'antd';
import type { PublisherTreeOut } from '@/api/generated/schemas';
import { ShowLink } from '@/components/common/ShowLink';
import { publisherRows } from './publisherRows';

const { Text } = Typography;

interface PersonPublishersCardProps {
  publishers?: PublisherTreeOut[];
}

export const PersonPublishersCard = ({
  publishers,
}: PersonPublishersCardProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const rows = publisherRows(publishers);

  return (
    <Card title={t('user_catalog.common.show.publishers')}>
      {rows.length === 0 ? (
        <Text type="secondary">
          {t('user_catalog.common.show.publishers_empty')}
        </Text>
      ) : (
        <Flex vertical gap={token.marginXS}>
          {rows.map((row) => (
            <Flex
              key={row.key}
              gap={token.marginXS}
              align="baseline"
              style={{
                paddingLeft: row.isImprint ? token.marginLG : 0,
                borderLeft: row.isImprint
                  ? `1px solid ${token.colorSplit}`
                  : undefined,
                marginLeft: row.isImprint ? token.marginXS : 0,
              }}
            >
              <ShowLink resource="user_catalog.publishers" id={row.id}>
                {row.name}
              </ShowLink>
              <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
                ID {row.id}
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
    </Card>
  );
};
